import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { MdError } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";

// import PhoneInput from "react-phone-number-input";
import { PhoneInput } from "react-contact-number-input";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { Link } from "react-router-dom";
// SERVICES
import confirmPassword from "../../../../../Services/confirmPass";
import FACodeSend from "../../../../../Services/FACodeSend";
import verifyFACode from "../../../../../Services/verifyFACode";
import updateUserDetails from "../../../../../Services/updateUserDetails";
import AuthSession from "../../../../../Services/getSessionAuth";
const Enable2FA = ({ show, setShow, setSwitchState, updateData }) => {
  const [form2, setForm2] = useState(false);
  const [form3, setForm3] = useState(false);
  const [form4, setForm4] = useState(false);
  const { t, i18n } = useTranslation("translation");

  // screen width for otp input
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // session data
  const getSessionData = () => {
    const userDetails_Session = JSON.parse(localStorage.getItem("session"));

    // Get the current date
    const currentDate = new Date();

    // Subtract 15 years from the current date
    currentDate.setFullYear(currentDate.getFullYear() - 15);

    // Format the date as "YYYY-MM-DD"
    const fifteenYearsAgo = currentDate.toISOString().substring(0, 10);
    return {
      _id: userDetails_Session._id,
      name: userDetails_Session.name,
      email: userDetails_Session.email,
      tfa:
        userDetails_Session.tfa !== undefined ? userDetails_Session.tfa : false,
      phone: userDetails_Session.phone ? userDetails_Session.phone : "",
      // dob: userDetails_Session.dob
      //   ? userDetails_Session.dob.substring(0, 10)
      //   : "2021-09-02",
      dob: userDetails_Session.dob
        ? userDetails_Session.dob.substring(0, 10)
        : fifteenYearsAgo,
      language: userDetails_Session.language
        ? userDetails_Session.language
        : "unknown",
      gender: userDetails_Session.gender
        ? userDetails_Session.gender
        : "unknown",
      country: userDetails_Session.country
        ? userDetails_Session.country
        : "N/A",
      password: userDetails_Session.password
        ? userDetails_Session.password
        : "N/A",
      profileIMG: userDetails_Session?.profile_image?.url
        ? userDetails_Session?.profile_image?.url
        : "",
      subscription: userDetails_Session.subscription,
      brand: userDetails_Session.brand,
      last4: userDetails_Session.last4,
    };
  };

  const [userDetails, setUserDetails] = useState(getSessionData());
  // USER INFO

  const [userInfo, setUserInfo] = useState({
    _id: userDetails._id,
  });

  // phone number
  const [value, setValue] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const handlePhoneNum = (newValue) => {
    setValue(newValue);
    if (newValue && newValue.countryCode && newValue.phoneNumber) {
      setPhoneNumber(newValue.countryCode.concat(newValue.phoneNumber));
      setUserInfo({
        ...userInfo,
        phone: newValue.countryCode.concat(newValue.phoneNumber),
      });
    } else {
      setPhoneNumber("");
    }
  };

  // SEND 2FA CODE ON PHONE NUMBER
  const sendCode = async () => {
    const codeObj = {
      email: email,
      phone: userDetails.phone ? userDetails.phone : phoneNumber,
    };
    await updateUserDetails(userInfo);
    await AuthSession();
    const updatedUserDetails = getSessionData();
    updateData(updatedUserDetails);
    setUserDetails(updatedUserDetails);

    FACodeSend(codeObj);
    setTimer(60);
  };

  // verfification code - OTP
  const [verificationCode, setVerificationCode] = useState("");
  const [wrongCode, setWrongCode] = useState(false);

  const verifyCode = async () => {
    const verifyObj = {
      email: email,
      code: verificationCode,
      token: localStorage.getItem("2fatoken"),
    };
    try {
      const result = await verifyFACode(verifyObj);
      if (result) {
        const FaStatus = {
          _id: userDetails._id,
          tfa: true,
        };
        await updateUserDetails(FaStatus);
        await AuthSession();
        const updatedUserDetails = getSessionData();
        setUserDetails(updatedUserDetails);
        updateData(updatedUserDetails);
        setForm4(true);
        setWrongCode(false);
        setVerificationCode(""); // Clear the password field
        localStorage.removeItem("2fatoken");
      }
    } catch (error) {
      setWrongCode(true);
      setTimeout(() => {
        setWrongCode(false);
      }, 3000);
    }
  };

  const handleClose = () => {
    setShow(false);
    setForm2(false);
    setForm3(false);
    setForm4(false);
    setSwitchState(userDetails.tfa);
    setConfirmPass("");
    setWrongPass(false);
  };
  const handleDone = () => {
    setShow(false);
    setForm2(false);
    setForm3(false);
    setForm4(false);
    setSwitchState(userDetails.tfa);
  };

  // email
  const [email, setEmail] = useState(
    localStorage.getItem("session")
      ? JSON.parse(localStorage.getItem("session")).email
      : "name@example.com"
  );

  // confirm password
  const [confirmPass, setConfirmPass] = useState("");
  const [wrongPass, setWrongPass] = useState(false);
  // verify password using login api
  const session = JSON.parse(localStorage.getItem("session") ?? "{}");

  const dataObj = {
    phone: session.phone,
    email: session.email,
    password: confirmPass,
  };
  const verifyPass = async () => {
    try {
      dataObj["isEmail"] = true;
      if (dataObj.email == "") {
        dataObj["isEmail"] = false;
      }
      const result = await confirmPassword(dataObj);
      if (result) {
        setForm2(true);
        setWrongPass(false);
        setConfirmPass(""); // Clear the password field
        // send code if session has phone number
        if (userDetails.phone.length > 0) {
          sendCode();
        }
      }
    } catch (error) {
      setWrongPass(true);
      setTimeout(() => {
        setWrongPass(false);
      }, 3000);
    }
  };
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval); // Stop the interval when timer reaches 0
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval); // Clear interval on component unmount
  }, [timer]);

  const handleResendClick = () => {
    if (timer <= 0) {
      sendCode();
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="enable-modal"
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>{t("Two-Step Authentication")}</Modal.Title>
      </Modal.Header>
      {!form2 ? (
        <>
          {" "}
          <Modal.Body style={{ marginLeft: "0.5rem" }}>
            <p>{t("To continue, please enter your password")}</p>
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label style={{ color: "var(--iq-body-text)" }}>
                  {t("password")}
                </Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t("Your password")}
                  value={confirmPass}
                  onChange={(e) => {
                    setConfirmPass(e.target.value);
                  }}
                />
              </Form.Group>
              {wrongPass && (
                <span style={{ color: "red" }}> Wrong Password!</span>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Cancel")}
            </Button>
            {/* CHECK THE PASSWORD FROM API IF TRUE setForm2(true) else show error */}
            <Button
              disabled={confirmPass.length < 5 ? true : false}
              variant="primary"
              onClick={verifyPass}
            >
              {t("Continue")}
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          {!form3 && userDetails.phone.length === 0 ? (
            <>
              <Modal.Body style={{ marginLeft: "0.5rem" }}>
                <p>
                  We will text a verification code to this mobile number
                  whenever you sign in to your account
                </p>
                <Form>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Phone Number</Form.Label>

                    <PhoneInput
                      placeholder="Enter Phone Number"
                      value={value}
                      onChange={handlePhoneNum}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                {/* CHECK THE phone number error from value state variable if no error use api and setForm3(true) else show error */}
                <Button
                  variant="primary"
                  onClick={() => {
                    setForm3(true);
                    sendCode();
                  }}
                >
                  Verify
                </Button>
              </Modal.Footer>
            </>
          ) : (
            <>
              {" "}
              {!form4 ? (
                <>
                  <Modal.Body style={{ marginLeft: "0.5rem" }}>
                    <p>
                      We’ve sent an SMS message containing a code to your mobile
                      device.
                      {/* Enter the authentication code below we sent to{" "}
                      {userDetails.phone.length > 0
                        ? userDetails.phone
                        : phoneNumber}{" "} */}
                    </p>
                    <Form>
                      <div className="otp-code">
                        {width > 425 ? (
                          <OtpInput
                            value={verificationCode}
                            onChange={setVerificationCode}
                            numInputs={6}
                            renderInput={(inputProps) => (
                              <input
                                {...inputProps}
                                className="OtpInput__input" // add class here
                              />
                            )}
                            renderSeparator={<span>-</span>}
                            inputStyle={{
                              width: "3rem",
                              height: "3rem",
                              margin: "0 0.2rem",

                              borderRadius: 2,

                              outline: "none",
                              textAlign: "center",
                              fontWeight: "400",
                            }}
                          />
                        ) : (
                          <OtpInput
                            value={verificationCode}
                            onChange={setVerificationCode}
                            numInputs={6}
                            renderInput={(inputProps) => (
                              <input
                                {...inputProps}
                                className="OtpInput__input" // add class here
                              />
                            )}
                            renderSeparator={<span>-</span>}
                            inputStyle={{
                              width: "2.2rem",
                              height: "2.2rem",
                              margin: "0 0.2rem",

                              borderRadius: 2,
                              padding: 0,
                              outline: "none",
                              textAlign: "center",
                              fontWeight: "400",
                            }}
                          />
                        )}

                        {wrongCode && (
                          <div>
                            <MdError style={{ color: "red" }} />{" "}
                            <span style={{ color: "red" }}>
                              Incorrect verification code
                            </span>
                          </div>
                        )}
                        {timer === 0 ? (
                          <p onClick={handleResendClick}>Resend Code</p>
                        ) : (
                          <p> Resend One Time Password in {timer} seconds</p>
                        )}
                        {/* <p onClick={sendCode}>Resend Code</p> */}
                      </div>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                      Cancel
                    </Button>
                    {/* CHECK THE code if its wrong show error else setForm4(true) */}
                    <Button variant="primary" onClick={verifyCode}>
                      Verify
                    </Button>
                  </Modal.Footer>
                </>
              ) : (
                <>
                  <Modal.Body style={{ marginLeft: "0.5rem" }}>
                    <div className="success2FA">
                      <AiOutlineCheckCircle
                        style={{ color: "var(--iq-primary)" }}
                        size={30}
                      />
                      <span style={{ color: "var(--iq-primary)" }}>
                        Successfully Enabled
                      </span>

                      {/* <span>Your phone number is set to {phoneNumber}</span> */}
                      <span>
                        Authentication Codes will be texted to{" "}
                        {userDetails.phone.length > 0
                          ? userDetails.phone
                          : phoneNumber}{" "}
                        for logging in.
                      </span>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={handleDone}>
                      Done
                    </Button>
                  </Modal.Footer>
                </>
              )}
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default Enable2FA;
